import React, { useState } from 'react'
import arrowBelow from '../../assets/img/icon/arrow-below.png';
import arrowRight from '../../assets/img/icon/arrow-right.svg';
import { FiHome } from 'react-icons/fi';
import { useNavigate, useLocation } from 'react-router-dom';
import { SlHome } from "react-icons/sl";

const SalesSubHeading = ({ heading, heading2, heading3 }) => {
    const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const handleMobileNavToggle = () => {
        setIsMobileNavOpen(!isMobileNavOpen);
    };

    const handleMobileNavItemClick = (item) => {
        setIsMobileNavOpen(false);
        // Handle navigation based on item
        navigate(`/${item}`);
    };

    return (
        <>
            {/* Page Header */}
            <div className={`page-header ${isMobileNavOpen ? 'mobile-menu-open' : ''}`}>
                <div className="page-title-section">
                    <div className="title-line"></div>
                    <div className="title-content">
                        <h1 className="page-title">{heading}</h1>
                    </div>
                </div>
                <div className="breadcrumb-navigation">
                    <span className="breadcrumb-item">
                        <SlHome size={16} />
                    </span>
                    <span className="breadcrumb-separator">|</span>
                    <span className="breadcrumb-item">분양안내</span>
                    {!heading3 && (
                        <>
                            <span className="breadcrumb-separator">|</span>
                            <span className={`breadcrumb-item ${heading && !heading2 ? 'active' : ''}`}>{heading}</span>
                        </>
                    )}
                    {heading2 && (
                        <>
                            <span className="breadcrumb-separator">|</span>
                            <span className="breadcrumb-item active">{heading2}</span>
                        </>
                    )}
                    {heading3 && (
                        <>
                            <span className="breadcrumb-separator">|</span>
                            <span className="breadcrumb-item active">{heading3}</span>
                        </>
                    )}

                </div>

                <div className="mobile-navigation-section">
                    <img src={arrowBelow} alt="mobile-nav-icon" onClick={handleMobileNavToggle} className={isMobileNavOpen ? 'active' : ''} />
                </div>

            </div>

            {/* Mobile Navigation */}
            {isMobileNavOpen && (
                <div className="mobile-navigation">

                    <div className="mobile-nav-items">
                        <div
                            className={`mobile-nav-item ${location.pathname.includes('sky-special-room')
                                || location.pathname.includes('outdoor-hall-sales')
                                || location.pathname.includes('sky-hall-vip-sales')
                                || location.pathname.includes('sky-hall-phoenix-room')
                                || location.pathname.includes('star-hall-sales')
                                || location.pathname.includes('sunlight-hall-sales')
                                || location.pathname.includes('s-hall-sales') ? 'active' : ''}`}
                            onClick={() => handleMobileNavItemClick('sky-special-room')}
                        >
                            <span>분양가격</span>
                            <img src={arrowRight} alt="arrow-right" />
                        </div>
                        <div
                            className={`mobile-nav-item ${location.pathname.includes('sales-info') ? 'active' : ''}`}
                            onClick={() => handleMobileNavItemClick('sales-info')}
                        >
                            <span>분양안내</span>
                            <img src={arrowRight} alt="arrow-right" />
                        </div>
                    </div>

                </div>
            )}
        </>
    )
};

export default SalesSubHeading;




